import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Close = ({ sx }) => {
  const theme = useTheme();

  return (
    <CloseIcon fontSize="medium" sx={{ ...tertiaryHoverSx(theme), ...sx }} />
  );
};
